import * as yup from 'yup';
import { models } from '../../../../types';

export const validationSchema = yup.object().shape({
    city: yup.string(),
    street: yup.string(),
    zipCode: yup.string(),
});

export const defaultValues: models.TSchools = {
    city: '',
    street: '',
    zipCode: '',
};
